import { render, staticRenderFns } from "./CustomerDepositListItem.vue?vue&type=template&id=66ffdcce&lang=pug&"
import script from "./CustomerDepositListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerDepositListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports